module.exports = __webpack_public_path__ + "img/phone.696782f2.svg";